import { Button } from "@material-ui/core";
import React from "react";
import Media from "react-media";
import { Route } from "react-router-dom";
import { HeaderDesktop } from "../../components/header/desktop/HeaderDesktop";
import { HeaderMobile } from "../../components/header/mobile/HeaderMobile";
import { MposLoader } from "../../components/loader/MposLoader";
import { RadioButton } from "../../components/radio-button/RadioButton";
import { TerminalUpdateOrRemoveRequest } from "../../models/TerminalUpdateOrRemove";
import { TidStatusDto } from "../../models/TidStatusDto";
import { IUserDto } from "../../models/UserDto";
import { MposWebPortalApi } from "../../services/api/MposWebPortalApi";
import { TerminalOperationType } from "../../utils/TerminalOperationTypeEnum";
import { UserType } from "../../utils/UserTypeEnum";
import "./ChooseTidUpdateOperation.css";
import * as querystring from "querystring";
import { GoogleTagManagerService } from "../../services/analitycs/GoogleTagManagerService";
import { TerminalItemDto } from "../../models/TerminalInfoDto";
import { Mapper } from "../../utils/Mapper";
import StateContextProvider from "../../context/StateContext";

export class ChooseTidUpdateOperation extends React.Component<any, any> {
    user: IUserDto;
    terminalType: any;
    selectedPos: string;
    tidOperation: number;

    constructor(props: any) {
        super(props);

        this.state = {
            selected: "first",
            showLoader: false,
            sameTerminalsType: false
        };

        this.user = this.props.location.state.user;
        this.terminalType = this.props.location.state.terminalType;
        this.selectedPos = this.props.location.state.selectedPos;
        this.tidOperation = this.props.location.state.tidOperation;
    }

    private renderDesktopHeader(): JSX.Element {
        return (
            <HeaderDesktop
                showBack={true}
                showLogout={false}
                showTitle={true}
                title={"Modifica l'ID Terminale"}
            />
        );
    }

    private renderMobileHeader(): JSX.Element {
        return (
            <HeaderMobile
                showBack={true}
                showLogout={false}
                showTitle={true}
                title={"Modifica l'ID Terminale"}
            />
        );
    }

    componentDidMount() {
        this.setState({
            sameTerminalsType: StateContextProvider.getInstance().getProp("sameTerminalsType"),
        });
        GoogleTagManagerService.getInstance().pushPageEvent(
            this.props.history.location.pathname,
            "Modifica l'ID Terminale",
            {}
        );
    }

    private changeStatus(status: string) {
        console.log("[ChooseTidUpdateOperation] Change status to: " + status);
        this.setState({ selected: status });
    }

    private manageOperation(history: any) {
        if (this.state.sameTerminalsType) {
            if (this.state.selected === "second") {
                this.setState({ showLoader: true });
                console.log("[ChooseTidUpdateOperation] Remove TID");
                if (this.selectedPos !== null) {
                    let request = new TerminalUpdateOrRemoveRequest(this.selectedPos, this.user.username);
                    MposWebPortalApi.getInstance().removeTerminalToUser(request).subscribe((result) => {
                        this.setState({ showLoader: false });
                        console.log("[ChooseTidUpdateOperation] Remove TID result: " + result);
                        let username = this.user.username;
                        let queryParams = { userType: UserType.STAFF, description: this.user.description !== null ? encodeURIComponent(this.user.description) : "", terminalStatus: TidStatusDto.NOT_ASSIGNED };
                        window.history.pushState(null, '', '/');
                        let link = `/users/${username}?${querystring.stringify(queryParams)}`;
                        history.push('/users', { data: { redirectTo: link } });
                    }, (error) => {
                        this.setState({ showLoader: false });
                        console.log("[ChooseTidUpdateOperation] Remove TID error: " + JSON.stringify(error));
                        history.goBack();
                    });
                } else {
                    this.setState({ showLoader: false });
                    history.goBack();
                }
            } else {
                history.push('/chooseTerminal', { headerTitle: "Modifica l'ID Terminale", tidOperation: TerminalOperationType.CHANGE_TERMINAL_ID_TO_STAFF_USER, user: this.user, terminalType: this.terminalType });
            }
        } else {
            if (this.state.selected === "second") {
                this.setState({ showLoader: true });
                console.log("[ChooseTidUpdateOperation] Remove TID");
                if (this.user.terminalInfo?.length !== 0) {
                    let request = new TerminalUpdateOrRemoveRequest(
                        this.selectedPos,
                        this.user.username
                    );
                    MposWebPortalApi.getInstance()
                        .removeTerminalToUser(request)
                        .subscribe(
                            (result) => {
                                this.setState({ showLoader: false });
                                console.log(
                                    "[ChooseTidUpdateOperation] Remove TID result: " + result
                                );
                                let username = this.user.username;
                                let queryParams = {
                                    userType: Mapper.mapItalianParamToUserType(this.user.userType),
                                    // userType: UserType.STAFF,
                                    description:
                                        this.user.description !== null
                                            ? encodeURIComponent(this.user.description)
                                            : "",
                                    terminalStatus: TidStatusDto.NOT_ASSIGNED,
                                };
                                window.history.pushState(null, "", "/");
                                let link = `/users/${username}?${querystring.stringify(
                                    queryParams
                                )}`;
                                history.push("/users", { data: { redirectTo: link } });
                            },
                            (error) => {
                                this.setState({ showLoader: false });
                                console.log(
                                    "[ChooseTidUpdateOperation] Remove TID error: " +
                                    JSON.stringify(error)
                                );
                                history.goBack();
                            }
                        );
                } else {
                    this.setState({ showLoader: false });
                    history.goBack();
                }
            } else {
                history.push("/chooseTerminal", {
                    headerTitle: "Modifica l'ID Terminale",
                    tidOperation: this.tidOperation,
                    user: this.user,
                    terminalType: this.terminalType,
                });
            }
        }
    }

    render() {
        return (
            <div id="main-container-choose-tid-operation">
                <Media
                    query="(max-width: 1064px)"
                    render={() => this.renderMobileHeader()}
                />
                <Media
                    query="(min-width: 1065px)"
                    render={() => this.renderDesktopHeader()}
                />
                {this.state.sameTerminalsType ? (
                    <div className={"choose-tid-operation-container-content"}>
                        <div>
                            <p className={"choose-tid-operation-title"}>Scegli cosa assegnare</p>
                            <RadioButton textName={"Un ID Terminale"} textDescription={"L’utente visualizzerà in App le transazioni e potrà accettare i pagamenti."}
                                value="first" selected={this.state.selected} onChange={() => this.changeStatus("first")} />
                            <RadioButton textName={"Nessun ID Terminale"} textDescription={"L’utente non potrà accedere all’App."}
                                value="second" selected={this.state.selected} onChange={() => this.changeStatus("second")} />
                        </div>
                        <div className={"choose-tid-button-go-container"}>
                            <Route render={({ history }) => {
                                return <Button id={"choose-tid-button-go"}
                                    type={"button"} onClick={() => {
                                        this.manageOperation(history);
                                    }}>AVANTI</Button>
                            }} />
                        </div>
                    </div>
                ) : (
                    <div className="choose-tid-operation-container-content">
                        <div>
                            <RadioButton
                                textName="Modifica ID Terminale"
                                textDescription="L'utente visualizzerà in App le transazioni e potrà accettare i pagamenti sul nuovo
                            ID Terminale."
                                value="first"
                                selected={this.state.selected}
                                onChange={() => this.changeStatus("first")}
                            />
                            <RadioButton
                                textName="Rimuovi ID Terminale"
                                textDescription={
                                    this.user.terminalInfo?.filter(
                                        (terminal: TerminalItemDto) =>
                                            terminal.termId !== "" &&
                                            terminal.terminalStatus !== TidStatusDto.NOT_ASSIGNED
                                    ).length === 2
                                        ? `L'utente non potrà più accettare i pagamenti con ${this.terminalType === "MPOS" ? "Mobile " : "Soft"
                                        }POS.`
                                        : "L'utente non potrà accedere all'App."
                                }
                                value="second"
                                selected={this.state.selected}
                                onChange={() => this.changeStatus("second")}
                            />
                        </div>
                        <div className="choose-tid-button-go-container">
                            <Route
                                render={({ history }) => {
                                    return (
                                        <Button
                                            id="choose-tid-button-go"
                                            type="button"
                                            onClick={() => {
                                                this.manageOperation(history);
                                            }}>
                                            AVANTI
                                        </Button>
                                    );
                                }}
                            />
                        </div>
                    </div>
                )}
                {
                    // @ts-ignore
                    <MposLoader show={this.state.showLoader} />
                }
            </div>
        );
    }
}
